import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useDocumentTitle from "../../utils/useDocumentTitle";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import { DashboardLayout } from "../../layouts/DashboardLayout";
import { useNotification } from "../../context/notification";
import NudgeService from "../../services/NudgeService";
import NudgeLogTable from "../../components/nudgeLog/NudgeLogTable";

export function NudgeLogSession(props) {
  useDocumentTitle(props.title);
  const { t } = useTranslation();
  const { sessionId } = useParams();
  const { addNotification } = useNotification();

  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchLogs = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await NudgeService.getSessionNudgeLogs(sessionId);
      const data = Array.isArray(response) ? response : Array.isArray(response?.data) ? response.data : [];
      setLogs(data);
    } catch (error) {
      addNotification(
        t("error.couldNotGetSession") || "Failed to load nudge logs",
        "error"
      );
    }
    setIsLoading(false);
  }, [sessionId, addNotification, t]);

  useEffect(() => {
    fetchLogs();
  }, [fetchLogs]);

  return (
    <DashboardLayout isDisableCampaignSelection={true}>
      <PageContent>
        <Section>
          <SectionTitle>
            {t("nudgeLog.sessionTitle") || "Nudge Logs - Session"} #{sessionId}
          </SectionTitle>

          <NudgeLogTable logs={logs} isLoading={isLoading} />
        </Section>
      </PageContent>
    </DashboardLayout>
  );
}